<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-佣金设置
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="分销类型：" >
        <el-radio-group v-model="form.commission_type" >
          <el-radio :label="'10'">统一返利</el-radio>
          <el-radio :label="'20'">按等级返利</el-radio>
        </el-radio-group>

      </el-form-item>
      <div v-if="form.commission_type ==20">
        <el-form-item label="佣金类型：" >
          <el-radio-group v-model="form.money_type" @change="changeGradeType">
            <el-radio :label="'10'">百分比</el-radio>
            <el-radio :label="'20'">固定金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="佣金设置：">
        <div class="max-w460">
          <el-table :data="gradeList" border  style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="佣金设置" width="300px">
              <template v-slot="scope">
                  <el-input type="number" min="0" v-model="scope.row.first_money" class="max-w460">
                    <template slot="prepend">
                      一级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                  <el-form-item v-if="basic.level >= 2">
                    <el-input type="number" min="0" v-model="scope.row.second_money" class="max-w460">
                      <template slot="prepend">
                        二级佣金：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-if="basic.level >= 3">
                    <el-input type="number" min="0" v-model="scope.row.third_money" class="max-w460">
                      <template slot="prepend">
                        三级佣金：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                  </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      </div>
      <div v-if="form.commission_type ==10">
        <el-form-item label="一级佣金比例 "  v-if="basic.level >=1">
          <el-input v-model="form.first_money" type="number" class="max-w460"></el-input>
          <div class="tips">佣金比例范围 0% - 100%</div>
        </el-form-item>
        <el-form-item label="二级佣金比例" v-if="basic.level >=2">
          <el-input v-model="form.second_money" type="number" class="max-w460"></el-input>
          <div class="tips">佣金比例范围 0% - 100%</div>
        </el-form-item>
        <el-form-item label="三级佣金比例  " v-if="basic.level ==3">
          <el-input v-model="form.third_money" type="number" class="max-w460"></el-input>
          <div class="tips">佣金比例范围 0% - 100%</div>
        </el-form-item>
      </div>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import PlusApi from '@/api/plus.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          money_type:'10',
          commission_type:'10',
        },
        /*商品列表*/
        productList: [],
        /*加载完成*/
        loading: false,
        basic:{},
        gradeList:[],
        unit: '%',

      };
    },
    props: {
      settingData: Object
    },
    created() {
      if(this.settingData.data.commission.values.money_type == '20'){
        this.unit = '元';
      }

      this.gradeList = this.settingData.gradeList;
      this.basic=this.settingData.data.basic.values;
      this.form=this.settingData.data.commission.values;

      if(this.form.commission_type =='20'){
        let first_money =[];
        first_money= JSON.parse(this.form.first_money)
        let second_money =[];
        second_money= JSON.parse(this.form.second_money)
        let third_money =[];
        third_money= JSON.parse(this.form.third_money)
        this.gradeList.forEach(item=>{
          this.$set(item, 'first_money', first_money[item.grade_id]?first_money[item.grade_id]:0)
          this.$set(item, 'second_money', second_money[item.grade_id]?second_money[item.grade_id]:0)
          this.$set(item, 'third_money', third_money[item.grade_id]?third_money[item.grade_id]:0)
        })
        console.log(first_money);
      }


    },

    methods: {
      /*转JSON字符串*/
      convertJson(list,type){
        let obj={};

        list.forEach(item=>{
          if(type ==10){
            obj[item.grade_id]=item.first_money?item.first_money:0;
          }
          if(type ==20){
            obj[item.grade_id]=item.second_money?item.second_money:0;
          }
          if(type ==30){
            obj[item.grade_id]=item.third_money?item.third_money:0;
          }
        });
        return JSON.stringify(obj);
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        if(params.commission_type ==20){
          params.first_money = self.convertJson(self.gradeList,10);
          params.second_money = self.convertJson(self.gradeList,20);
          params.third_money = self.convertJson(self.gradeList,30);
        }

        // console.log(params);
        // return;
        PlusApi.commission(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*换算单位*/
      changeGradeType: function(val) {
        if (val == '10') {
          this.unit = '%';
        } else {
          this.unit = '元';
        }
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Commission.vue